import { Player } from './player';

export const CHARACTERS: Player[] = [
	{
		id: 0,
		name: 'Eva Rast',
		shortName: 'Eva',
		description: '',
		playerPower: 0,
		powerName: 'Speed',
		powerDescription: 'You may move an extra space each turn',
		portrait: '',
		headshot: 'blank.gif',
		avatar: '',
		avatarStyle: { top: '11.4%', left: '54.75%' },
		forwardCamp: '',
		campStyle: { top: '11.4%', left: '52.25%' },
		nativeStats: { Brains: 1, Brawn: 1, Bravado: 1 },
		calculatedStats: { Brains: 1, Brawn: 1, Bravado: 1 },
		displayStats: { Brains: '1', Brawn: '1', Bravado: '1' },
		movement: 2,
		location: 0,
		startLocation: 0,
		campLocation: 0,
		wounds: [],
		items: [],
		XP: []
	},
	{
		id: 0,
		name: 'Kiki Manjaro',
		shortName: 'Kiki',
		description: '',
		playerPower: 0,
		powerName: '',
		powerDescription: '',
		portrait: '',
		headshot: 'blank.gif',
		avatar: '',
		avatarStyle: { top: '36.4%', left: '54.75%' },
		forwardCamp: '',
		campStyle: { top: '36.4%', left: '52.25%' },
		nativeStats: { Brains: 1, Brawn: 1, Bravado: 1 },
		calculatedStats: { Brains: 1, Brawn: 1, Bravado: 1 },
		displayStats: { Brains: '1', Brawn: '1', Bravado: '1' },
		movement: 1,
		location: 0,
		startLocation: 0,
		campLocation: 0,
		wounds: [],
		items: [],
		XP: []
	},
	{
		id: 0,
		name: 'Anna Purna',
		shortName: 'Anna',
		description: '',
		playerPower: 1,
		powerName: 'Efficient',
		powerDescription: 'You may carry an extra item',
		portrait: '',
		headshot: 'blank.gif',
		avatar: '',
		avatarStyle: { top: '61.4%', left: '54.75%' },
		forwardCamp: '',
		campStyle: { top: '61.4%', left: '52.5%' },
		nativeStats: { Brains: 1, Brawn: 1, Bravado: 1 },
		calculatedStats: { Brains: 1, Brawn: 1, Bravado: 1 },
		displayStats: { Brains: '1', Brawn: '1', Bravado: '1' },
		movement: 1,
		location: 0,
		startLocation: 0,
		campLocation: 0,
		wounds: [],
		items: [],
		XP: []
	},
	{
		id: 0,
		name: 'Maddie Horn',
		shortName: 'Maddie',
		description: '',
		playerPower: 2,
		powerName: 'Vigorous',
		powerDescription: 'You may take an additional Wound before needing to go back and heal',
		portrait: '',
		headshot: 'blank.gif',
		avatar: '',
		avatarStyle: { top: '86.4%', left: '54.75%' },
		forwardCamp: '',
		campStyle: { top: '86.4%', left: '52.25%' },
		nativeStats: { Brains: 1, Brawn: 1, Bravado: 1 },
		calculatedStats: { Brains: 1, Brawn: 1, Bravado: 1 },
		displayStats: { Brains: '1', Brawn: '1', Bravado: '1' },
		movement: 1,
		location: 0,
		startLocation: 0,
		campLocation: 0,
		wounds: [],
		items: [],
		XP: []
	}
];
